// extracted by mini-css-extract-plugin
export var alignCenter = "_b5-d";
export var bannerShown = "_b5-6";
export var buttonContent = "_b5-0";
export var cardList = "_b5-1";
export var centerContent = "_b5-2";
export var chevron = "_b5-3";
export var closePanelButton = "_b5-k";
export var conversationContextContainer = "_b5-l";
export var conversationDetailContainer = "_b5-4";
export var detailWrapper = "_b5-7";
export var dropdownButton = "_b5-e";
export var dropdownTitle = "_b5-9";
export var fullHeight = "_b5-5";
export var hidden = "_b5-a";
export var icon = "_b5-b";
export var mergeSuggestionWrapper = "_b5-m";
export var panel = "_b5-i";
export var portalButtonsWrapper = "_b5-c";
export var right = "_b5-j";
export var tableSummaryContainer = "_b5-8";
export var tableSummaryHeader = "_b5-g";
export var threeDotsButton = "_b5-f";
export var wide = "_b5-h";